import React from 'react';

// Lightweight VisuallyHidden without external deps (Radix polyfill)
const hiddenStyles: React.CSSProperties = {
  position: 'absolute',
  border: 0,
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
};

export const VisuallyHidden = React.forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(function VisuallyHidden(
  { style, ...props },
  ref
) {
  return <span ref={ref} style={{ ...hiddenStyles, ...style }} {...props} />;
});

export default VisuallyHidden;
